export default __webpack_public_path__ + "media/images/societe-jaune-e0ed2df961871ced3d1f5806a4c68c43.png";